import { DiscoveryApi, FetchApi } from '@backstage/frontend-plugin-api';
import { Cluster } from '@internal/backstage-plugin-catalog-devops-common';
import {
  DefaultApiClient,
  DefaultApiResponse,
} from '@internal/backstage-plugin-devops-react';
import { ClustersApi } from './ClustersApi';

export class ClustersApiClient extends DefaultApiClient implements ClustersApi {
  public constructor(options: {
    discoveryApi: DiscoveryApi;
    fetchApi: FetchApi;
  }) {
    super({
      backendName: 'catalog',
      ...options,
    });
  }

  async createClusterEntity(data: Cluster): Promise<DefaultApiResponse> {
    const urlSegment = `v2/cluster`;
    return await this.post<Cluster>(urlSegment, data);
  }

  async editClusterEntity(
    id: string,
    data: Cluster,
  ): Promise<DefaultApiResponse> {
    const urlSegment = `v2/cluster/${id}`;
    return await this.put<Cluster>(urlSegment, data);
  }

  async deleteClusterEntity(id: string): Promise<DefaultApiResponse> {
    const urlSegment = `v2/cluster/${id}`;
    return await this.delete(urlSegment);
  }

  async triggerProvider(providerType: string): Promise<DefaultApiResponse> {
    const urlSegment = `v2/cluster/provider/trigger?providerType=${encodeURIComponent(
      providerType,
    )}`;
    return await this.get(urlSegment);
  }
}
